// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"CustomTextFieldWithCloseIcon__mainContainer___1OfHI","clearIcon":"CustomTextFieldWithCloseIcon__clearIcon___2_Lla"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomTextFieldWithCloseIcon/CustomTextFieldWithCloseIcon.css
// module id = 990
// module chunks = 0